import {Directive, Renderer,ElementRef,Input} from '@angular/core';

@Directive({
  selector: '[focus-input]'
})
export class FocusInputDirective {

  constructor(private el: ElementRef,
              private renderer: Renderer) {
    setTimeout(() => {
      this.check();
    }, 0);
  }

  check (){
    let pos = this.el.nativeElement.selectionStart;
    this.el.nativeElement.setSelectionRange(0,pos);
    this.renderer.invokeElementMethod(this.el.nativeElement, 'focus');
  }

}

export const FocusInput_DIRECTIVES = [
  FocusInputDirective
];


// WEBPACK FOOTER //
// /app/src/app/directives/focus-input/focus-input.directive.ts